
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { EnrichedSearchRequest } from '@/pages/external-search/requests/enrich-search-requests';
import NDateTimeLabel from '@/uikit/datetime/NDateTimeLabel.vue';
import { dataModule } from '@/store/data';
import NButton from '@/uikit/buttons/NButton.vue';
import { RouterModule } from '@/store/router';

@Options({
  name: 'ExternalSearchRequestInfo',
  components: { NButton, NDateTimeLabel }
})
export default class ExternalSearchRequestInfo extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: EnrichedSearchRequest;

  get dataModule() {
    return dataModule;
  }

  showResults() {
    this.$emit('action', 'show-results');
  }

  navigateToUser(id: number) {
    RouterModule.navigateToUser(id);
  }
}
